import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: 10,
    marginBottom: 10,
    borderTop: `1px solid rgba(0,0,0,0.05)`,
  },
}));
